const countryHelpers = {

  flagEmoji(countryCode: string){
    const codePoints = countryCode
      .toUpperCase()
      .split('')
      .map(char => 127397 + char.charCodeAt(0));
    return String.fromCodePoint(...codePoints);
  }
}

export default countryHelpers;
